/**
 * El desenlace, con color. El orden de gravedad ya sube los problemas arriba;
 * el color los hace saltar a la vista (SC-002).
 */
import { Badge, type PropsBadge } from './ui/badge'

type Tono = NonNullable<PropsBadge['tone']>

const DESENLACE: Record<string, { tono: Tono; texto: string }> = {
    handover: { tono: 'danger', texto: 'Escalado' },
    abandoned: { tono: 'warning', texto: 'Abandonado' },
    in_progress: { tono: 'info', texto: 'En curso' },
    expired: { tono: 'neutral', texto: 'Caducado' },
    booked: { tono: 'success', texto: 'Reservado' },
    modified: { tono: 'success', texto: 'Modificado' },
    cancelled: { tono: 'neutral', texto: 'Cancelado' },
    informed: { tono: 'info', texto: 'Consultó' },
    waiting: { tono: 'warning', texto: 'En espera' },
    unmatched: { tono: 'neutral', texto: 'No encajó' },
}

export function OutcomeBadge({ outcome }: { outcome: string }) {
    const d = DESENLACE[outcome] ?? { tono: 'neutral' as const, texto: outcome }
    return <Badge tone={d.tono}>{d.texto}</Badge>
}
